import React, { Fragment, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import Container from 'reactstrap/lib/Container';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities, CmsModel, CmsPaths } from 'client/data/models/cms';
import { EditorialMap } from 'client/tracking/maps/editorial';
import { EngineTypeQuizMap } from 'client/tracking/maps/common/engine-type-quiz';
import { HomepageAdExtensionMap } from 'client/tracking/maps/common/homepage-ad-extension';
import { TrackingHandler } from 'client/tracking/handler';
import { DEFAULT_CONTENT, extractMetadata } from 'client/data/cms/content';
import {
  AD_UNIT_LIMIT,
  NUMBER_OF_ENTRIES_BETWEEN_AD_UNITS,
} from 'site-modules/shared/constants/editorial/research-article';
import { DEALERLESS_OEM } from 'site-modules/shared/constants/oem';
import { EV_RANGE_LEADERBOARD_HOSTING_PAGE } from 'client/site-modules/editorial/constants/ev-range-charts';
import { HERO_HEIGHT, HERO_SIZE } from 'site-modules/shared/constants/editorial/editorial';
import { EDITORIAL_HEADER_SRC_INLINE } from 'site-modules/shared/constants/editorial/editorial-header';
import { CAR_NEWS_RSS_FEED_URL } from 'site-modules/shared/constants/editorial/rss';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { getCanonical } from 'site-modules/shared/utils/seo-helper';
import {
  getResearchArticleIndexPath,
  getTypeArticleConfigPath,
  getTypeArticleContentPath,
} from 'site-modules/editorial/utils/content-path';
import { getMoreInCategoriesLinks } from 'site-modules/editorial/utils/entry-converter';
import { getBreadcrumbsFromConfig, getResearchArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { scrollToHash } from 'client/utils/scroll';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';
import { isCarNews as isCarNewsCategory } from 'client/site-modules/editorial/utils/car-news';
import { isEvArticle } from 'site-modules/editorial/utils/ev';
import { getHeroPhoto } from 'client/site-modules/editorial/utils/hero-photo';
import { getEndlessScrollMainId } from 'site-modules/editorial/utils/endless-scroll';
import { transformAllAuthorsContent } from 'site-modules/shared/utils/editorial/author';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { NativeVideoAd } from 'site-modules/shared/components/native-ad/video/video-native-ad';
import { ArticleMetadata } from 'site-modules/shared/components/editorial/article-metadata/article-metadata';
import { SponsoredArticleHeader } from 'site-modules/editorial/components/sponsored-article-header/sponsored-article-header';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ArticlePhoto } from 'site-modules/shared/components/editorial/article-photo/article-photo';
import { ArticleContent } from 'site-modules/editorial/components/article-content/article-content';
import { AllAuthorsMetadata } from 'site-modules/shared/components/editorial/author-metadata/all-authors-metadata';
import { ArticleMenu } from 'site-modules/shared/components/editorial/article-menu/article-menu';
import { EmbeddedYoutubeAsync } from 'site-modules/shared/components/video/embedded-youtube/embedded-youtube-async';
import { EmbeddableInfographic } from 'site-modules/shared/components/infographics/embeddable-infographic/embeddable-infographic';
import { InlineArticle } from 'site-modules/editorial/components/inline-article/inline-article';
import { InlineVideoSponsor } from 'site-modules/editorial/components/inline-video-sponsor/inline-video-sponsor';
import { Share } from 'site-modules/shared/components/share/share';
import { ArticleTable } from 'site-modules/shared/components/editorial/article-table/article-table';
import { ArticleOffersAd } from 'site-modules/shared/components/native-ad/article-module-ad/article-offers-ad';
import { DynamicLeaderboard } from 'site-modules/editorial/components/dynamic-leaderboard/dynamic-leaderboard';
import { DynamicLeaderboardTable } from 'site-modules/editorial/components/dynamic-leaderboard-table/dynamic-leaderboard-table';
import { EvRangeLeaderBoard } from 'site-modules/editorial/components/ev-range-leaderboard/ev-range-leaderboard';
import { UdragsLeaderboardUI } from 'site-modules/editorial/components/udrags-leaderboard/udrags-leaderboard';
import { FastChargingLeaderboardUI } from 'site-modules/editorial/components/fast-charging-leaderboard/fast-charging-leaderboard';
import { EvRangeTable } from 'site-modules/shared/components/editorial/ev-range-table/ev-range-table';
import { CompareModule } from 'site-modules/editorial/components/type/compare-module/compare-module';
import { EndlessScroll } from 'site-modules/editorial/components/endless-scroll/endless-scroll';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { CarNewsMarquee } from 'site-modules/shared/components/upper-funnel/home-marquee/car-news-marquee';
import { ArticleSrpLink } from 'site-modules/editorial/components/article-srp-link/article-srp-link';
import { ArticleEvToolLink } from 'site-modules/editorial/components/article-ev-tool-link/article-ev-tool-link';
import { RightRailStickyInterscroll } from 'site-modules/editorial/pages/type/right-rail-sticky-interscroll';
import { PageLinksWidget } from 'site-modules/shared/components/page-links-widget/page-links-widget';
import { ArticleReadyForEv } from 'site-modules/editorial/components/article-ready-for-ev/article-ready-for-ev';
import { ArticleTreehousePromotion } from 'site-modules/editorial/components/article-treehouse-promotion/article-treehouse-promotion';
import { SocialEmbed } from 'site-modules/editorial/components/social-embed/social-embed';
import { EngineTypeQuiz } from 'site-modules/shared/components/engine-type-quiz/engine-type-quiz';
import { VideoCard } from 'site-modules/editorial/components/car-news/video-card/video-card';
import { CardsCarousel } from 'site-modules/editorial/components/car-news/cards-carousel/cards-carousel';
import { YoutubeVideoModalAsync } from 'site-modules/shared/components/youtube-video-modal/youtube-video-modal-async';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { NewsSubscriptionButton } from 'site-modules/editorial/components/news-subscription-button/news-subscription-button';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

import './article.scss';

const NO_ENDLESS_SCROLL_ARTICLES = [
  'honda-crv-toyota-rav4-kia-sportage-hybrid-suv-comparison-video',
  'hands-free-driving-comparison',
  'toyota-land-cruiser-lexus-gx-off-road-comparison-video',
];
const MORE_LINKS_NUMBER = 3;
const canonicalOrigin = 'https://www.edmunds.com';

const MMRECT_OPTIONS = {
  adName: 'mmrect',
  xs: true,
  sm: true,
  md: true,
  verticalOffset: '100%',
  useMinHeight: true,
  dfpCollapse: true,
  customSizes: [[1, 1], [320, 50], [300, 90], [300, 180], [300, 250]],
};

function TypeArticleUI({
  content,
  allAuthors,
  config,
  slug,
  splat,
  articleId,
  pathname,
  isMobile,
  isEndlessScrollArticle,
  core6373EndlessScroll,
}) {
  const [videoModalData, setVideoModalData] = useState({});
  const [isVideoModalOpen, toggleVideoModalOpen] = useToggle(false);
  useEffect(() => {
    TrackingHandler.useMap({ ...EditorialMap, ...EngineTypeQuizMap, ...HomepageAdExtensionMap });
    scrollToHash(window.location.hash);
  }, []);

  const onToggleVideoModal = useCallback(newVideoModalData => {
    toggleVideoModalOpen();
    setVideoModalData(newVideoModalData || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let configContent = config;
  if (configContent.children && configContent.children().length > 0) {
    configContent = configContent.children()[0];
  }
  const canonicalURL = getCanonical(content);
  const suppressMarquee = content.metadata('suppressMarquee').boolean();
  const contentVehicle = get(content, 'vehicles[0]');
  const pageHref = canonicalOrigin + pathname;
  const moreInCategories = configContent.child(`right-rail-links-${slug}`).children();
  const articleMenuLinks = getMoreInCategoriesLinks(canonicalURL, moreInCategories, false, MORE_LINKS_NUMBER);
  const inlineContent = configContent.child(`inline-content-${slug}`);
  const inlineContentPositions = inlineContent
    .metadata('position')
    .value()
    .split(',')
    .map(position => parseInt(position, 10));
  const isCarNewsArticle = isCarNewsCategory(slug);
  const breadcrumbsData = isCarNewsArticle
    ? getResearchArticleBreadcrumbs([slug], content.title, pathname)
    : getBreadcrumbsFromConfig(config, pathname, content.title);
  const sponsoredContent = content.child('sponsored-content');
  const isSponsoredContent = sponsoredContent.metadata('sponsored-title').value() === 'true';
  const { title, subtitle } = content;
  const heroPhoto = getHeroPhoto(content);
  const isSuvBuyingGuideArticle = pathname.includes('suv-buying-guide');
  const isEvLeaderBoardPage = pathname === EV_RANGE_LEADERBOARD_HOSTING_PAGE;
  const isEvArticlePage = isEvArticle({ slug, categories: content.categories });
  const isNoEndlessScrollArticle = !core6373EndlessScroll && NO_ENDLESS_SCROLL_ARTICLES.includes(articleId);

  const contentEntries = [];
  let entriesToRenderCount = 0;
  let mmrectPos = 1;

  content.children().forEach(entry => {
    contentEntries.push(entry);
    entriesToRenderCount += 1;

    // Ad Units
    const suitableAdPosition = entriesToRenderCount % NUMBER_OF_ENTRIES_BETWEEN_AD_UNITS === 0;
    if (suitableAdPosition && mmrectPos <= AD_UNIT_LIMIT) {
      if (entriesToRenderCount === NUMBER_OF_ENTRIES_BETWEEN_AD_UNITS * 2) {
        contentEntries.push({ id: 'video-ad-unit' });
      } else {
        contentEntries.push({
          id: 'ad-unit',
          options: { ...MMRECT_OPTIONS, position: `${mmrectPos}`, renderWhenViewable: isMobile },
        });
        mmrectPos += 1;
      }
    }
  });
  if (isSuvBuyingGuideArticle) {
    contentEntries.splice(contentEntries.length - 1, 0, {
      id: 'ad-unit',
      options: { ...MMRECT_OPTIONS, position: `${mmrectPos}`, renderWhenViewable: isMobile },
    });
  }

  if (content.children().length < NUMBER_OF_ENTRIES_BETWEEN_AD_UNITS * 2) {
    contentEntries.push({ id: 'video-ad-unit' });
  }

  let hasVideo = false;
  let hasVideoModal = false;
  const contentConfig = contentEntries.reduce((entries, entry, index) => {
    switch (entry.id) {
      case 'html': {
        const htmlContent = entry.metadata('htmlContent').value();
        entries.push({
          content: <ArticleContent content={htmlContent} />,
          key: `article-${entry.id}-${index}`,
        });

        break;
      }
      case 'table': {
        if (isEvLeaderBoardPage) {
          entries.push({
            content: (
              <EvRangeTable
                shareOptions={{
                  canonical: canonicalURL,
                  pageTitle: title,
                }}
              />
            ),
            key: `article-${entry.id}-${index}`,
          });

          break;
        }

        entries.push({
          content: (
            <ArticleTable
              entry={entry}
              shareOptions={{
                contentId: content.id,
                canonical: canonicalURL,
                entryPath: [entry.id],
                pageTitle: title,
              }}
            />
          ),
          key: `article-${entry.id}-${index}`,
        });
        break;
      }
      case 'photo': {
        const photos = entry.links();
        entries.push({
          content: <ArticlePhoto photos={photos} />,
          key: `article-${entry.id}-${index}`,
        });
        break;
      }
      case 'video': {
        const youtubeVideoId = entry.metadata('youtube-videoid').value();
        let videoId = null;
        const addlProps = {};
        if (youtubeVideoId) {
          videoId = youtubeVideoId;
          addlProps.creativeId = `video-${youtubeVideoId}`;
          addlProps.videoTitle = 'inline article video';
        }

        if (videoId) {
          const videoComponent = <EmbeddedYoutubeAsync videoId={videoId} {...addlProps} />;

          entries.push({
            content: hasVideo ? videoComponent : <ScrollElement id="videos">{videoComponent}</ScrollElement>,
            key: `article-${entry.id}-${index}`,
            hashAnchorId: `vid_${videoId}`,
          });
          hasVideo = true;
        }
        break;
      }
      case 'videos': {
        const { title: videosTitle } = entry;
        hasVideoModal = true;

        entries.push({
          content: (
            <Fragment>
              {!!videosTitle && <h2 className="heading-3 mb-1_5">{videosTitle}</h2>}
              <CardsCarousel
                content={entry}
                CardComponent={VideoCard}
                showArrows={!isMobile}
                centerMode={isMobile}
                openVideoModal={onToggleVideoModal}
                isMobile={isMobile}
              />
            </Fragment>
          ),
          key: `article-${entry.id}-${index}`,
        });

        break;
      }
      case 'compare': {
        entries.push({
          content: <CompareModule entry={entry} />,
          key: `compare-${entry.id}-${index}`,
        });
        break;
      }
      case 'leaderboard': {
        entries.push({
          content: <DynamicLeaderboard entry={entry} pathname={pathname} isMobile={isMobile} />,
          key: `leaderboard-${index}`,
        });
        break;
      }
      case 'leaderboard-table': {
        entries.push({
          content: <DynamicLeaderboardTable entry={entry} isMobile={isMobile} />,
          key: `leaderboard-table-${index}`,
        });
        break;
      }
      case 'info-graphic': {
        if (
          entry
            .child('vehicles')
            .metadata('type')
            .value() === 'u-drags'
        ) {
          entries.push({
            content: <UdragsLeaderboardUI content={entry} pathname={pathname} />,
            key: `info-graphic-${index}`,
          });

          break;
        }

        if (
          entry
            .child('vehicles')
            .metadata('type')
            .value() === 'fast-charging'
        ) {
          entries.push({
            content: <FastChargingLeaderboardUI content={entry} pathname={pathname} isMobile={isMobile} />,
            key: `info-graphic-${index}`,
          });

          break;
        }

        if (isEvLeaderBoardPage) {
          entries.push({
            content: <EvRangeLeaderBoard />,
            key: `info-graphic-${index}`,
          });

          break;
        }

        entries.push({
          content: (
            <EmbeddableInfographic
              imgSrc={entry.metadata('media-image').value()}
              imgAlt={entry.metadata('imageAltText').value()}
              imgUrl={entry.metadata('imageURL').value()}
              clickableUrl={entry.metadata('clickableURL').value()}
              btnText={entry.metadata('buttonTitle').value()}
              hideShareButton={entry.metadata('hideShareButton').value() === 'true'}
            />
          ),
          key: `info-graphic-${index}`,
        });
        break;
      }
      case 'social-embed': {
        entries.push({
          key: `social-embed-${index}`,
          content: <SocialEmbed content={entry.metadata('htmlContent').value()} />,
        });
        break;
      }
      case 'editorial-high-impact': {
        if (entry.hasMetadata('enabled')) {
          entries.push({
            content: (
              <div className="clearfix">
                <div className="high-impact mx-auto">
                  <NativeAd
                    adNameWired="edhighimpact"
                    adNameMobile="medhighimpact"
                    nativeStyle="none"
                    position={'1'}
                    renderWhenViewable={false}
                    refreshable={false}
                    all
                  />
                </div>
              </div>
            ),
            key: 'edhighimpact-ad-block',
          });
        }
        break;
      }
      case 'inline-video-ad': {
        // Inline Video Ad
        const inlineVideoAd = entry;
        const context = {
          sponsorTitle: inlineVideoAd.metadata('sponsorTitle').value(),
        };
        context.type = 'Youtube';
        context.videoId = inlineVideoAd.metadata('youtube-videoid').value();
        context.playlistId = '';

        // Feed the object to the component
        entries.push({
          content: <InlineVideoSponsor {...context} />,
          key: `article-${entry.id}-video-ad-${index}`,
        });
        break;
      }
      case 'ad-unit': {
        const {
          adName,
          position,
          xs,
          sm,
          md,
          lg,
          xl,
          renderWhenViewable,
          customSizes,
          verticalOffset,
          useMinHeight,
        } = entry.options;
        entries.push({
          content: (
            <Col
              xs={12}
              className={classnames(`ad-unit-${adName} hidden-lg-up`, {
                'mt-1_5': isMobile,
                'mb-2': !isMobile,
              })}
            >
              <NativeAd
                adNameWired={adName}
                adNameMobile={adName}
                nativeStyle="none"
                position={position}
                wiredBreakpoints={{
                  xl: !!xl,
                  lg: !!lg,
                  md: !!md,
                }}
                mobileBreakpoints={{
                  xs: !!xs,
                  sm: !!sm,
                  md: !!md,
                }}
                renderWhenViewable={!!renderWhenViewable}
                verticalOffset={verticalOffset}
                useMinHeight={useMinHeight}
                refreshable={false}
                showLabel
                customSizes={customSizes}
              />
            </Col>
          ),
          key: `ad-unit-${index}`,
        });
        break;
      }
      case 'video-ad-unit': {
        entries.push({
          content: (
            <Col
              xs={12}
              className={classnames({
                'mt-1': isMobile,
                'd-none': !isMobile,
              })}
            >
              <NativeVideoAd mobileOnly useMinHeight />
            </Col>
          ),
          key: `native-video-ad`,
        });
        break;
      }
      case 'article-offers-ad': {
        entries.push({
          content: <ArticleOffersAd entry={entry} isMobile={isMobile} />,
          key: `article-offers-ad-${index}`,
        });
        break;
      }
      default:
        break;
    }
    const positionIndex = inlineContentPositions.indexOf(index);
    if (positionIndex >= 0) {
      const inlineContentChild = inlineContent.child(`inline-content-${positionIndex + 1}`);
      if (inlineContentChild.id) {
        // If child not empty, id should exist
        const metadata = extractMetadata(['heading', 'image', 'url', 'title', 'text', 'ctaText'], inlineContentChild);

        entries.push({
          content: <InlineArticle content={metadata} />,
          key: `article-${inlineContentChild.id}-${index}-inline`,
        });
      }
    }
    return entries;
  }, []);

  const hasSrpLink =
    isCarNewsArticle &&
    !!(get(contentVehicle, 'make') && get(contentVehicle, 'model')) &&
    !DEALERLESS_OEM.includes(makeNiceName(get(contentVehicle, 'make')));

  const hasRightRailLinks = !!configContent
    .child(`right-rail-links-${slug}`)
    .metadata('moduleHeader')
    .value();

  const addCustomSizeWired = [[300, 600]];

  return (
    <Fragment>
      <div
        id={getEndlessScrollMainId(isEndlessScrollArticle)}
        className="editorial-type-article pos-r mb-3"
        data-ad-zone={articleId}
      >
        <img
          src={EDITORIAL_HEADER_SRC_INLINE[isMobile]}
          alt=""
          fetchpriority="high"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: HERO_HEIGHT[isMobile],
          }}
        />
        <Container style={heroPhoto ? undefined : { height: HERO_HEIGHT[isMobile] }}>
          <Breadcrumbs className="ps-0 text-white mb-1_5 mb-md-2" data={breadcrumbsData} />
          <Row>
            <Col xs={12} lg={9}>
              <h1
                className={classnames('text-white fw-bold', {
                  'mb-0-75': !!subtitle,
                  'size-36': !isMobile,
                  'size-24': isMobile,
                })}
              >
                {title}
              </h1>
              {!!subtitle && <h2 className="size-16 text-white fw-medium mb-2">{subtitle}</h2>}
            </Col>
          </Row>
        </Container>
        <Container>
          {isSponsoredContent && (
            <SponsoredArticleHeader sponsoredContent={sponsoredContent} title={title} canonicalURL={canonicalURL} />
          )}
          <Row className="mb-2">
            <Col xs={12} lg={8} data-sticky-bottom-boundary>
              {!!heroPhoto && (
                <AspectRatioContainer className="rounded-12 mb-1_5">
                  <img src={getFullImageUrl(heroPhoto.href, HERO_SIZE[isMobile])} alt={heroPhoto.title || ''} />
                </AspectRatioContainer>
              )}
              {!isSponsoredContent && (
                <ArticleMetadata
                  className="mb-2"
                  content={content}
                  allAuthors={allAuthors}
                  creativeId="edm-entry-article-metadata"
                  rssLink={isCarNewsArticle ? CAR_NEWS_RSS_FEED_URL : undefined}
                  isMobile={isMobile}
                />
              )}
              {contentConfig.map((item, index) => (
                <Fragment key={item.key}>
                  <div
                    className={classnames('research-article-section', {
                      'mb-2': !(index === 1 && hasSrpLink) && !item.key.includes('ad-unit'),
                    })}
                    data-tracking-parent={`edm-entry-research-article-section-${index}`}
                    name={item.hashAnchorId || null}
                  >
                    {item.content}
                  </div>
                  {index === 1 && hasSrpLink && (
                    <ArticleSrpLink
                      className="mb-2 px-1_5 px-md-0"
                      contentVehicle={contentVehicle}
                      isMobile={isMobile}
                    />
                  )}
                  {index === 1 && !isEndlessScrollArticle && isCarNewsArticle && !suppressMarquee && (
                    <CarNewsMarquee className="mt-2 mb-2" scrollBtnPosition={isMobile ? 'start' : 'end'} />
                  )}
                  {index === 1 && !hasSrpLink && (
                    <ArticleEvToolLink
                      categories={content.categories}
                      slug={slug}
                      className="mb-2 px-1_5 px-md-0"
                      isMobile={isMobile}
                    />
                  )}
                  {index === 1 && (
                    <ArticleTreehousePromotion
                      className="mb-3_5"
                      categories={content.categories}
                      slug={slug}
                      fallback={<ArticleReadyForEv categories={content.categories} slug={slug} className="mb-3_5" />}
                    />
                  )}
                </Fragment>
              ))}
              <div className="text-center text-md-start">
                <Share url={pageHref} title={content.title} />
              </div>
              {!isSponsoredContent && (
                <AllAuthorsMetadata
                  allAuthors={allAuthors}
                  authorNameNoLink={content.metadata('authorNameNoLink').value()}
                />
              )}
              {isCarNewsArticle && <NewsSubscriptionButton className="mt-2 px-1_5 px-md-0" isMobile={isMobile} />}
            </Col>
            <Col className="hidden-lg-down py-3_5 my-3_5" lg={4}>
              <RightRailStickyInterscroll>
                <MrectNative
                  wrapperClass="hidden-lg-down mb-3_5"
                  position={'1'}
                  refreshable={false}
                  wiredBreakpoints={{ lg: true, xl: true }}
                  wiredOnly
                  useMinHeight
                />
                {hasRightRailLinks && (
                  <ArticleMenu
                    className="mb-1_5"
                    title={configContent
                      .child(`right-rail-links-${slug}`)
                      .metadata('moduleHeader')
                      .value()}
                    links={articleMenuLinks}
                    data-tracking-parent="edm-entry-right-rail-menu"
                  />
                )}
                <MrectNative
                  wrapperClass="hidden-lg-down mb-3_5"
                  position={'2'}
                  refreshable={false}
                  wiredBreakpoints={{ lg: true, xl: true }}
                  wiredOnly
                  useMinHeight
                />
                <NativeVideoAd
                  wrapperClass="native-video-wrapper mb-3_5"
                  wiredOnly
                  wiredBreakpoints={{
                    lg: true,
                    xl: true,
                  }}
                  useMinHeight
                />
                {slug === 'truck' && !isMobile && (
                  <NativeAd
                    adNameWired="mrect"
                    nativeStyle="none"
                    wrapperClass="hidden-lg-down"
                    position={'3'}
                    refreshable={false}
                    wiredBreakpoints={{ lg: true, xl: true }}
                    useMinHeight
                    renderWhenViewable
                    showLabel
                    addCustomSizesWired={addCustomSizeWired}
                  />
                )}
                {slug !== 'truck' && !isMobile && (
                  <MrectNative
                    wrapperClass="hidden-lg-down"
                    position={'3'}
                    refreshable={false}
                    wiredBreakpoints={{ lg: true, xl: true }}
                    wiredOnly
                    useMinHeight
                    renderWhenViewable
                    addCustomSizesWired={addCustomSizeWired}
                  />
                )}
              </RightRailStickyInterscroll>
            </Col>
          </Row>
        </Container>
        {!isEndlessScrollArticle && (
          <Fragment>
            {isEvArticlePage && (
              <Container className="mb-2">
                <Row>
                  <Col xs={12} lg={8}>
                    <EngineTypeQuiz />
                  </Col>
                </Row>
              </Container>
            )}
          </Fragment>
        )}
      </div>
      {hasVideoModal && (
        <YoutubeVideoModalAsync
          onToggleModal={onToggleVideoModal}
          isOpen={isVideoModalOpen}
          videoId={videoModalData.videoId}
          videoAspectRatio={videoModalData.videoAspectRatio}
          creativeId={videoModalData.creativeId}
          videoTitle={videoModalData.videoTitle}
        />
      )}
      {isCarNewsArticle && !isEndlessScrollArticle && (
        <FeatureFlag name="endless-scroll">
          {enabled =>
            enabled && !isNoEndlessScrollArticle ? (
              <Experiment name="core-6549-infinite-scroll" showDefault>
                <Recipe name="ctrl" isDefault>
                  <EndlessScroll hostArticleParams={{ articleCategory: slug, articleId, splat }} />
                </Recipe>
                <Recipe name="chal">
                  <PageLinksWidget className="container mb-3" />
                </Recipe>
              </Experiment>
            ) : (
              <PageLinksWidget className="container mb-3" />
            )
          }
        </FeatureFlag>
      )}
    </Fragment>
  );
}

TypeArticleUI.propTypes = {
  content: CmsEntities.Content,
  config: CmsEntities.Content,
  allAuthors: PropTypes.shape({
    author: CmsEntities.Content,
    coAuthor: CmsEntities.Content,
    editor: CmsEntities.Content,
  }),
  slug: PropTypes.string.isRequired,
  splat: PropTypes.string,
  articleId: PropTypes.string,
  pathname: PropTypes.string,
  isMobile: PropTypes.bool,
  isEndlessScrollArticle: PropTypes.bool,
  core6373EndlessScroll: PropTypes.bool,
};

TypeArticleUI.defaultProps = {
  content: DEFAULT_CONTENT,
  allAuthors: {
    author: DEFAULT_CONTENT,
    coAuthor: DEFAULT_CONTENT,
    editor: DEFAULT_CONTENT,
  },
  config: DEFAULT_CONTENT,
  pathname: '',
  splat: '',
  articleId: '',
  isMobile: false,
  isEndlessScrollArticle: false,
  core6373EndlessScroll: false,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
  pathname: get(state, 'pageContext.location.pathname'),
  breakpoint: state.pageContext.breakpointDeprecated2,
  core6373EndlessScroll: !!state.featureFlags?.core6373EndlessScroll,
});

export const TypeArticle = connect(mapStateToProps)(
  connectToModel(TypeArticleUI, {
    allAuthors: bindToPath(
      ({ slug, articleId, splat }) =>
        CmsPaths.buildAllAuthorsPath({
          contentPath: isCarNewsCategory(slug)
            ? getResearchArticleIndexPath(slug, articleId, splat)
            : getTypeArticleContentPath(slug, articleId),
        }),
      CmsModel,
      transformAllAuthorsContent
    ),
    config: bindToContent(
      ({ slug, articleId }) => !isCarNewsCategory(slug) && getTypeArticleConfigPath(slug, articleId)
    ),
  })
);
